// eslint-disable-next-line import/prefer-default-export
export const TYPES_TABLE_REF = 'TYPES_TABLE_REF';
export const EXTENDED_NAMESPACES_TABLE_REF = 'EXTENDED_NAMESPACES_TABLE_REF';
export const EXCLUDED_NAMESPACES_TABLE_REF = 'EXCLUDED_NAMESPACES_TABLE_REF';
